<div
	class="flex items-center justify-between px-6 -mx-5 overflow-scroll border-b border-gray-200 hide-scrollbar sm:px-0 sm:mx-0"
>
	<nav class="flex space-x-6 whitespace-nowrap" aria-label="Tabs">
		@for (label of navigationLabels() | keyvalue: unsorted; track label) {
			<li class="inline-block list-none cursor-pointer" role="presentation">
				<a
					class="inline-flex items-center py-6 text-base font-medium text-gray-500 border-b-2 border-transparent cursor-pointer tab-hover"
					data-toggle="tab"
					(click)="selectKey.emit(label.key)"
					[ngClass]="{ 'tab-selected': selectedKey() === label.key }"
				>
					{{ label.value }}
				</a>
			</li>
		}
	</nav>
</div>
